import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Wallet, AlertTriangle, Frown, ShieldAlert } from 'lucide-react';
const problems = [{
  icon: Wallet,
  text: 'Gastás plata en materiales sin saber cómo usarlos',
  color: 'text-accent-pink',
  bg: 'bg-accent-pink/10',
  border: 'border-accent-pink/20'
}, {
  icon: AlertTriangle,
  text: 'Tus estampas salen mal y no sabés por qué',
  color: 'text-accent-yellow',
  bg: 'bg-accent-yellow/10',
  border: 'border-accent-yellow/20'
}, {
  icon: Frown,
  text: 'Te frustrás porque el proceso parece complicado',
  color: 'text-accent-cyan',
  bg: 'bg-accent-cyan/10',
  border: 'border-accent-cyan/20'
}, {
  icon: ShieldAlert,
  text: 'Tenés miedo de empezar y perder dinero',
  color: 'text-red-500',
  bg: 'bg-red-500/10',
  border: 'border-red-500/20'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProblemSection() {
  return <section className="py-8 bg-darker relative border-y border-white/5" data-id="element-182">
      <div className="container mx-auto px-4" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-5" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-185">
            ¿TE SENTÍS <span className="text-accent-pink" data-id="element-186">IDENTIFICADO</span>{' '}
            CON ESTO?
          </h2>
          <div className="w-20 h-1 bg-accent-pink mx-auto rounded-full" data-id="element-187" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-2 lg:grid-cols-4 gap-3 max-w-5xl mx-auto" data-id="element-188">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className={`flex flex-col items-center text-center p-4 rounded-xl bg-card border ${problem.border} hover:scale-105 transition-transform duration-300`} data-id="element-189">
              <div className={`w-10 h-10 rounded-full ${problem.bg} flex items-center justify-center mb-2`} data-id="element-190">
                <problem.icon className={`w-5 h-5 ${problem.color}`} data-id="element-191" />
              </div>
              <p className="text-sm font-medium text-gray-200" data-id="element-192">
                {problem.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}